function getEvents(pageId) {
  return {
    events: {
      e: {
        id: "e",
        name: "",
        animationType: "preset",
        eventTypeId: "MOUSE_CLICK",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-2",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|accordion`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|accordion`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: null,
          scrollOffsetUnit: null,
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1700579047656,
      },
      "e-2": {
        id: "e-2",
        name: "",
        animationType: "preset",
        eventTypeId: "MOUSE_SECOND_CLICK",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-2",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|accordion`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|accordion`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: null,
          scrollOffsetUnit: null,
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1700579047656,
      },
      "e-3": {
        id: "e-3",
        name: "",
        animationType: "preset",
        eventTypeId: "MOUSE_CLICK",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-4",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|b168f67a-a8bd-d46d-6187-039ef34c9c1b`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|b168f67a-a8bd-d46d-6187-039ef34c9c1b`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: null,
          scrollOffsetUnit: null,
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1700579047656,
      },
      "e-4": {
        id: "e-4",
        name: "",
        animationType: "preset",
        eventTypeId: "MOUSE_SECOND_CLICK",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-2",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-3",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|b168f67a-a8bd-d46d-6187-039ef34c9c1b`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|b168f67a-a8bd-d46d-6187-039ef34c9c1b`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: null,
          scrollOffsetUnit: null,
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1700579047656,
      },
      "e-5": {
        id: "e-5",
        name: "",
        animationType: "preset",
        eventTypeId: "MOUSE_CLICK",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-6",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|b168f67a-a8bd-d46d-6187-039ef34c9c54`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|b168f67a-a8bd-d46d-6187-039ef34c9c54`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: null,
          scrollOffsetUnit: null,
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1700579047656,
      },
      "e-6": {
        id: "e-6",
        name: "",
        animationType: "preset",
        eventTypeId: "MOUSE_SECOND_CLICK",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-2",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-5",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|b168f67a-a8bd-d46d-6187-039ef34c9c54`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|b168f67a-a8bd-d46d-6187-039ef34c9c54`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: null,
          scrollOffsetUnit: null,
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1700579047656,
      },
    },
    actionLists: {
      a: {
        id: "a",
        title: "Career 2 accordion [Open]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-n",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 500,
                  target: {
                    useEventTarget: "SIBLINGS",
                    selector: ".career2_list-wrapper",
                    selectorGuids: ["6058444d-5b17-dcac-180c-9bcd8634f79b"],
                  },
                  widthValue: 100,
                  heightValue: 0,
                  widthUnit: "%",
                  heightUnit: "px",
                  locked: false,
                },
              },
            ],
          },
          {
            actionItems: [
              {
                id: "a-n-2",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 400,
                  target: {
                    useEventTarget: "SIBLINGS",
                    selector: ".career2_list-wrapper",
                    selectorGuids: ["6058444d-5b17-dcac-180c-9bcd8634f79b"],
                  },
                  widthValue: 100,
                  widthUnit: "%",
                  heightUnit: "AUTO",
                  locked: false,
                },
              },
              {
                id: "a-n-3",
                actionTypeId: "TRANSFORM_ROTATE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 400,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".career2_icon-wrapper",
                    selectorGuids: ["6058444d-5b17-dcac-180c-9bcd8634f796"],
                  },
                  zValue: 180,
                  xUnit: "DEG",
                  yUnit: "DEG",
                  zUnit: "deg",
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: true,
        createdOn: 1628306749914,
      },
      "a-2": {
        id: "a-2",
        title: "Career 2 accordion [Close]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-2-n",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 400,
                  target: {
                    useEventTarget: "SIBLINGS",
                    selector: ".career2_list-wrapper",
                    selectorGuids: ["6058444d-5b17-dcac-180c-9bcd8634f79b"],
                  },
                  widthValue: 100,
                  heightValue: 0,
                  widthUnit: "%",
                  heightUnit: "px",
                  locked: false,
                },
              },
              {
                id: "a-2-n-2",
                actionTypeId: "TRANSFORM_ROTATE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 400,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".career2_icon-wrapper",
                    selectorGuids: ["6058444d-5b17-dcac-180c-9bcd8634f796"],
                  },
                  zValue: 0,
                  xUnit: "DEG",
                  yUnit: "DEG",
                  zUnit: "deg",
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: false,
        createdOn: 1628306749914,
      },
    },
    site: {
      mediaQueries: [
        { key: "main", min: 992, max: 10000 },
        {
          key: "medium",
          min: 768,
          max: 991,
        },
        { key: "small", min: 480, max: 767 },
        { key: "tiny", min: 0, max: 479 },
      ],
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
